import React, { useState } from "react";
import {
  Box,
  Grid,
  Typography,
  List,
  Button,
  Divider,
  useMediaQuery,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  ListItem,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import styles from "./../../personal-loan-landing.module.css";
import { PaperComponent } from "@/components";
import ContentHeader from "../ContentHeader/ContentHeader";
import { WEB_COLORS } from "@/lib/constants";

const loanTypes = [
  "Emergency Loan",
  "Marriage Loan",
  "Instant Cash Loan",
  "Travel Loan",
  "Short Term Loan",
  "Salary Advance Loan",
  "Education Loan",
];

const loanDetails = {
  "Marriage Loan": [
    "Covers Wedding Costs: Borrow from ₹50,000 to ₹5 Lakhs to manage wedding expenses without financial stress.",
    "Quick & Easy Process: Fully digital application with minimal hassle.",
    "Instant Approval: Fast loan approval to ensure timely financial support.",
    "Low Salary Requirement: Available to individuals with a minimum monthly salary of just ₹15,000.",
    "Flexible Tenure: Repay comfortably over 12 to 36 months.",
    "Attractive Interest Rates: Starting from 18% per annum.",
  ],
  // Add other loan types and details as needed
};

const LoanTypesSection = () => {
  const [expanded, setExpanded] = useState("Marriage Loan");
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const handleAccordionChange = (type) => (_, isExpanded) => {
    setExpanded(isExpanded ? type : false);
  };

  return (
    <Box sx={{ p: { xs: 2, md: 8 } }}>
      <ContentHeader
        heading={"Types Of Personal Loan For Your Goals"}
        paragraph={"One Loan, Many Dreams — Find the Right Fit for Your Needs."}
      />

      {isMobile ? (
        <Box>
          {loanTypes.map((type) => {
            const isSelected = expanded === type;
            return (
              <Accordion
                key={type}
                expanded={isSelected}
                onChange={handleAccordionChange(type)}
                sx={{
                  backgroundColor: isSelected ? "#00F2000F" : "#fff",
                  border: isSelected
                    ? "1px solid #00F200"
                    : "1px solid #e0e0e0",
                  borderRadius: 1,
                  mb: 2,
                }}
              >
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                  <Typography fontWeight={isSelected ? "bold" : "normal"}>
                    {type}
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Divider sx={{ mb: 1 }} />
                  <Box component="ul" sx={{ pl: 2 }}>
                    <List className={styles["type-of-loan-list"]}>
                      {(loanDetails[type] || []).map((point, index) => (
                        <ListItem key={index}>
                          <Typography variant="body2" color="text.secondary">
                            {point}
                          </Typography>
                        </ListItem>
                      ))}
                    </List>
                  </Box>
                  <Box textAlign={"center"} mt={2}>
                    <Button
                      variant="contained"
                      size="large"
                      sx={{ backgroundColor: WEB_COLORS.darkTeal }}
                      fullWidth={isMobile}
                    >
                      <Typography color={"#fff"} textTransform={"none"}>
                        Apply Now
                      </Typography>
                    </Button>
                  </Box>
                </AccordionDetails>
              </Accordion>
            );
          })}
        </Box>
      ) : (
        <Grid container spacing={4}>
          <Grid item xs={12} md={4}>
            {loanTypes?.map((type, index) => (
              <PaperComponent
                key={`${type}-${index}`}
                onClick={() => setExpanded(type)}
                paperStyle={{
                  backgroundColor: expanded === type ? WEB_COLORS.darkTeal : "#fff",
                  color: expanded === type ? "#fff" : WEB_COLORS.darkTeal,
                }}
              >
                {type}
              </PaperComponent>
            ))}
          </Grid>

          <Grid item xs={12} md={8}>
            <PaperComponent
              paperStyle={{
                py: 3,
                height: "90%",
              }}
            >
              <Box
                display={"flex"}
                flexDirection={"row"}
                justifyContent={"space-between"}
                mb={2}
              >
                <Typography variant="h6" fontWeight="bold">
                  {expanded}
                </Typography>
                <Button
                  variant="contained"
                  size="large"
                  sx={{ backgroundColor: WEB_COLORS.darkTeal }}
                >
                  <Typography color={"#fff"} textTransform={"none"}>
                    Apply Now
                  </Typography>
                </Button>
              </Box>
              <Divider sx={{ mb: 2 }} />
              <Box component="ul" sx={{ pl: 2 }}>
                {(loanDetails[expanded] || []).map((point, index) => (
                  <li key={index}>
                    <Typography variant="body2" color="text.secondary">
                      {point}
                    </Typography>
                  </li>
                ))}
              </Box>
            </PaperComponent>
          </Grid>
        </Grid>
      )}
    </Box>
  );
};

export default LoanTypesSection;
